<form *ngIf="inputFormGroup" [formGroup]="inputFormGroup" class="clamp-form-main">
    <app-clamp-manufacturer [form]="inputFormGroup" [enable]="enable" (misalignmentFactorCheck)="selectedCheck($event)"></app-clamp-manufacturer>

    <app-misalignment-factor *ngIf="router.url != '/settings/idms' && checkMisalignmentFactor" [form]="inputFormGroup" [enable]="enable">
    </app-misalignment-factor>

    <!-- here min and max pipe size for only pipecodes in iDMS Settings -->
    <app-min-max-pipe-size
        *ngIf="router.url == '/settings/idms'"
        [enable]="enable"
        [form]="inputFormGroup"
        [calcType]="2"
        class="flange-inner-form"
    ></app-min-max-pipe-size>

    <app-clamp-size *ngIf="router.url != '/settings/idms'" [form]="inputFormGroup" [manufacturerId]="manufacturerId"></app-clamp-size>

    <app-pipe-size *ngIf="router.url != '/settings/idms'" [form]="inputFormGroup" [clampId]="clampId"></app-pipe-size>

    <app-bolt-material class="input-wrapper-list" [form]="inputFormGroup" [enable]="enable" [isGetAllBoltMaterials]="true"></app-bolt-material>

    <app-clamp-material [form]="inputFormGroup" [enable]="enable" [manufacturerId]="manufacturerId"></app-clamp-material>

    <app-pipe-schedule [form]="inputFormGroup" [clampId]="clampId" [enable]="enable"></app-pipe-schedule>

    <app-hub-material [form]="inputFormGroup" [clampMaterialId]="clampMaterialId" [enable]="enable"></app-hub-material>

    <app-seal-ring-material
        [form]="inputFormGroup"
        [manufacturerId]="manufacturerId"
        [hubMaterialId]="hubMaterialId"
        [enable]="enable"
    ></app-seal-ring-material>

    <app-seal-ring
        *ngIf="router.url != '/settings/idms'"
        [form]="inputFormGroup"
        [clampId]="clampId"
        [pipeScheduleId]="pipeScheduleId"
        [pipeSizeId]="pipeSizeId"
        [enable]="enable"
    ></app-seal-ring>

    <app-bolt-type [form]="inputFormGroup" [clampId]="clampId" [enable]="enable"></app-bolt-type>

    <div class="">
        <a
            href="javascript:void(0)"
            *ngIf="idmsSharedService.enableConfirmWithRouter(1)"
            class="btn font-weight-bold py-3 px-6 secondary-ebtn informateFullWidth"
            (click)="inputConfirmClicked()"
        >
            <!-- Confirm -->
            {{ 'STANDARD_FLANGE_PAGE.BUTTONS_TEXT.CONFIRM' | transloco }}
        </a>
    </div>
</form>
